import { useEffect, useState } from "react";
import { LuCheck } from "react-icons/lu";
import Modal from "../../../common/Modal";
import Button from "../../../common/Buttons";
import TextInput from "../../../common/TextInput";
import PhoneInput from "../../../common/PhoneInput";
import { EMAIL_REGEX } from "../../../utils/Constant";
import { isValidPhone, phoneError } from "../../../utils/phone";

const EMPTY_FORM = {
  name: "",
  email: "",
  contactNumber: "",
  person: "",
  address: "",
  taxId: "",
};

export default function SupplierFormModal({ open, mode, initialValue, onClose, onSubmit, loading }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [touched, setTouched] = useState({});

  useEffect(() => {
    if (open) {
      setForm(mode === "edit" && initialValue ? { ...EMPTY_FORM, ...initialValue } : EMPTY_FORM);
      setTouched({});
    }
  }, [open, mode, initialValue]);

  const markTouched = (field) => () => setTouched((t) => ({ ...t, [field]: true }));
  // const setField = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));
  const setField = (field) => (e) => {
    let value = e.target.value;
    setForm((prev) => ({ ...prev, [field]: value}));
  };
  const setContactNumber = (value) => setForm((prev) => ({ ...prev, contactNumber: value }));

  const nameError = touched.name && !form.name.trim() ? "Name is required." : "";
const emailError =
  touched.email && !form.email
    ? "Email is required"
    : touched.email && !EMAIL_REGEX.test(form.email.trim())
    ? "Please enter a valid email address"
    : "";
 const contactError =
  touched.contactNumber && !form.contactNumber
    ? "Contact number is required"
    : touched.contactNumber
    ? phoneError(form.contactNumber)
    : "";
  const taxIdError = touched.taxId && !form.taxId.trim() ? "Tax ID is required." : "";

  const isValid =
    form.name.trim() !== "" &&
    form.email.trim() !== "" &&
    // EMAIL_REGEX.test(form.email) &&
     EMAIL_REGEX.test(form.email.trim()) &&
    isValidPhone(form.contactNumber) &&
    form.taxId.trim() !== "";

  const handleSubmit = () => {
    setTouched({ name: true, email: true, contactNumber: true, taxId: true });
    if (!isValid) return;
    // onSubmit(form);
        onSubmit({
      ...form,
      name: form.name.trim(),
      email: form.email.trim(),
      contactNumber: form.contactNumber.trim(),
      person: form.person.trim(),
      address: form.address.trim(),
      taxId: form.taxId.trim(),
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={mode === "edit" ? "Edit Supplier" : "Add Supplier"}
      footer={
        <Button
          variant="solid"
          icon={<LuCheck size={15} />}
          loading={loading}
          disabled={!isValid}
          onClick={handleSubmit}
        >
          {mode === "edit" ? "Save Changes" : "Add Supplier"}
        </Button>
      }
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="sm:col-span-2">
          <TextInput
            label="Name"
            required
            value={form.name}
            onChange={setField("name")}
            onBlur={markTouched("name")}
            error={nameError}
            placeholder="Supplier name"
          />
        </div>

        <TextInput
          label="Email"
          required
          type="email"
          value={form.email}
          onChange={setField("email")}
          onBlur={markTouched("email")}
          error={emailError}
          placeholder="name@supplier.com"
        />
        <PhoneInput
          label="Contact Number"
          required
          value={form.contactNumber}
          onChange={setContactNumber}
          onBlur={markTouched("contactNumber")}
          error={contactError}
          placeholder="Phone number"
        />

        <TextInput
          label="Contact Person"
          value={form.person}
          onChange={setField("person")}
          placeholder="Primary contact"
        />
        <TextInput
          label="Tax ID"
          required
          value={form.taxId}
          onChange={setField("taxId")}
          onBlur={markTouched("taxId")}
          error={taxIdError}
          placeholder="Tax identification number"
        />

        <div className="sm:col-span-2">
          <TextInput
            label="Address"
            value={form.address}
            onChange={setField("address")}
            placeholder="Address"
          />
        </div>
      </div>
    </Modal>
  );
}